import axios from 'axios';
import authConfig from '../auth_config.json';

class UserService {
    domain = authConfig.domain;

    login(phoneNumber, user, reload = false, appName = "doinsport", lang = "fr"){

        if (appName === "circusmons" || appName === "gent" || appName === "niklaas" ) {
            appName = "Circus%20Arena";
        }

        if (appName === "lamaisondusquash" ) {
            appName = "lamaison";
        }

        localStorage.removeItem('token');
        return new Promise((resolve, reject) => {
            phoneNumber = phoneNumber.split(' ').join('');
            phoneNumber = phoneNumber.replace('+', "*");
            axios({url: this.domain+'user/phone_login?lang='+lang+'&app_name='+appName+'&phoneNumber='+phoneNumber+'&', method: 'GET' })
                .then(resp => {
                    return resolve(resp.data);
                })
                .catch(err => {
                    localStorage.removeItem('token');
                    return reject(err);
                })
        })
    }

    register(data) {
        let token = localStorage.getItem('token');
        return new Promise((resolve, reject) => {
            axios({
                url: this.domain+'registration/register_v2',
                method: 'POST',
                data: data,
            })
                .then(resp => {
                    return resolve(resp.data['hydra:member'])
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

    getCredits(userId, clubId) {
        console.log("GET CREDIT METHODE");
        let token = localStorage.getItem('token');

        console.log('URL : '+this.domain+'user/detail/credit/'+userId+'/'+clubId);

        return new Promise((resolve, reject) => {
            axios({
                url: this.domain+'user/detail/credit/'+userId+'/'+clubId,
                method: 'GET',
                headers: {Authorization: 'Bearer '+token},
            })
                .then(resp => {
                    console.log("GET CREDIT METHODE");
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

    checkPhone(phoneNumber, user, reload = false, appName = "doinsport", lang = "fr") {

        if (appName === "circusmons" || appName === "gent" || appName === "niklaas" ) {
            appName = "Circus%20Arena";
        }

        if (appName === "lamaisondusquash" ) {
            appName = "lamaison";
        }

        localStorage.removeItem('token');
        return new Promise((resolve, reject) => {
            phoneNumber = phoneNumber.split(' ').join('');
            phoneNumber = phoneNumber.replace('+', "*");
            axios({url: this.domain+'user/phone_validate?lang='+lang+'&app_name='+appName+'&phoneNumber='+phoneNumber, method: 'GET' })
                .then(resp => {
                    return resolve(resp.data);
                })
                .catch(err => {
                    localStorage.removeItem('token');
                    return reject(err);
                })
        })
    }

    userMe (token) {
        if (token === null) {
            token = localStorage.getItem('token');
        }

        return new Promise((resolve, reject) => {
            axios({
                url: this.domain+'user/me',
                method: 'GET',
                headers: {Authorization: 'Bearer '+token}
            })
                .then(resp => {
                    const user = JSON.stringify(resp.data);
                    localStorage.setItem('userInfo', user);
                    return resolve(resp.data)
                })
                .catch(err => {
                    localStorage.removeItem('token');
                    return reject(err)
                })
        })
    }

    handlerError(error) {
        if (error.code == 401) {
            this.logout(commit).then(()=>{
                this.router.next('/login');
            });
        }
    }

    logout(){
        return new Promise((resolve) => {
            commit('logout');
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('userRole');
            delete axios.defaults.headers.common['Authorization'];
            resolve();
        })
    }

}

const userService = new UserService();

export default userService;
